import { GoPlus } from 'react-icons/go'
import { useClube } from '../contextClube'

import { Container } from './style';

export function ButtonCreate({ handleClickCreateButton }) {
    const { setModalFormsGenericIsOpen } = useClube()

    function handleClick() {
        handleClickCreateButton()
        setModalFormsGenericIsOpen(true)
    }

    return(
        <Container onClick={handleClick}>
            <GoPlus />
        </Container>
    )
}
